import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { createContext, useContext } from 'react';

import { CancelSalePopin } from '#src/components/offer/CancelSalePopin/index.tsx';

import type { SingleSaleOfferContext_anyCard } from './__generated__/index.graphql.ts';

export interface SingleSaleOfferPopinInfo {
  slug: string;
}

type SingleSaleOfferContext = {
  showPopin: (singleSaleOfferPopinInfo: SingleSaleOfferPopinInfo) => void;
};

export const SingleSaleOfferContext =
  createContext<SingleSaleOfferContext | null>(null);

export const useSingleSaleOfferContext = () =>
  useContext(SingleSaleOfferContext)!;

export const singleSaleOfferContextFragments = {
  anyCard: gql`
    fragment SingleSaleOfferContext_anyCard on AnyCardInterface {
      slug
      ...CancelSalePopin_anyCard
    }
    ${/* oxlint-disable-next-line sorare/no-detached-fragments */ ''}
    ${CancelSalePopin.fragments.anyCard}
  ` as TypedDocumentNode<SingleSaleOfferContext_anyCard>,
};
